export const CV_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;

const ACCEPTED_CV_EXTENSIONS = ['.pdf', '.doc', '.docx'];
const ACCEPTED_CV_MIME_TYPES = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]);

export function validateCvUploadFile(file) {
  if (!file) {
    return {
      valid: false,
      message: 'Choose your CV before uploading.',
    };
  }

  if (Number(file.size || 0) <= 0) {
    return {
      valid: false,
      message: 'This file looks empty. Please choose your CV again.',
    };
  }

  if (file.size > CV_UPLOAD_MAX_BYTES) {
    return {
      valid: false,
      message: 'Your CV must be 10MB or smaller.',
    };
  }

  const lowerName = String(file.name || '').toLowerCase();
  const extensionAccepted = ACCEPTED_CV_EXTENSIONS.some((extension) => lowerName.endsWith(extension));
  const mimeAccepted = ACCEPTED_CV_MIME_TYPES.has(String(file.type || '').toLowerCase());

  if (!extensionAccepted && !mimeAccepted) {
    return {
      valid: false,
      message: 'Upload your CV as a PDF or Word document only.',
    };
  }

  return {
    valid: true,
    message: '',
  };
}

export const CV_UPLOAD_GUIDANCE = [
  'Use one clear CV file: PDF, DOC or DOCX.',
  'Make sure your name is visible on the CV.',
  'Cover the last 10 years, including work, education, training, caring breaks or unemployment.',
];
